import ValueChain from "../ValueChain";
import TextConfidential from "./TextConfidentialComponent";
import TextNoConfidential from "./TextNoConfidentialComponent";

interface NumberComponentProps {
  numberLabel: string;
  numberValid: boolean;
  numberValue: number | null;
  numberName: string;
  max: number;
  min: number;
  onChange: (e: any) => void;
  display: boolean;
}

function NumberComponent({
  numberLabel,
  numberName,
  numberValid = true,
  numberValue,
  onChange,
  display,
  max,
  min,
}: NumberComponentProps) {
  var componentValue;
  var numberValidComponent = true;
  if (numberValue == null) {
    componentValue = undefined;
    numberValidComponent = false;
  } else {
    componentValue = numberValue;
  }
  console.log(numberValidComponent);
  return (
    <div className={display ? "hidden-content" : "visible-content"}>
      <div className="form-group">
        <label className="control-label">{numberLabel}</label>
        <input
          type="number"
          max={max}
          min={min}
          className={
            numberValid && numberValidComponent
              ? "form-control"
              : "form-control is-invalid"
          }
          value={componentValue}
          name={numberName}
          step={1}
          onChange={onChange}
          placeholder="-"
        />
      </div>
    </div>
  );
}

export default NumberComponent;
